import departFinder from "./departFinder.vue";
export default departFinder;
